import { render, staticRenderFns } from "./orderSettlement.vue?vue&type=template&id=49c42258&scoped=true&"
import script from "./orderSettlement.vue?vue&type=script&lang=js&"
export * from "./orderSettlement.vue?vue&type=script&lang=js&"
import style0 from "./orderSettlement.vue?vue&type=style&index=0&id=49c42258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c42258",
  null
  
)

export default component.exports